"use client";

import { useEffect, useState } from "react";
import styles from "./VerificationBanner.module.scss";
import { useAuth, useSteps } from "@/hooks";
import { useLocale, useTranslations } from "@/i18n";
import { Button, Flex } from "@vetty/ui";
import { APP_ORIGIN } from "@/constants";

export const VerificationBanner = () => {
  const t = useTranslations("verification.banner");
  const locale = useLocale();
  const [isMobile, setIsMobile] = useState(false);
  const { user } = useAuth();
  const { currentStep } = useSteps();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const POINTS = [
    {
      label: t("features.anatomySkills"),
      iconUrl: "/assets/award-icon.svg",
    },
    {
      label: t("features.communityCollaboration"),
      iconUrl: "/assets/message-square-icon.svg",
    },
    {
      label: t("features.anytimeUse"),
      iconUrl: "/assets/tablet-icon.svg",
    },
  ];

  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__overheader"]}>
        {t("welcome")}
        <span> {user?.firstName}</span>
      </div>

      <h1 className={styles["comp__header"]}>
        {currentStep === 1 && t("steps.verifyEmail")}
        {currentStep === 2 && t("steps.optionalPhone")}
        {currentStep === 3 && t("steps.getStarted")}
      </h1>

      <Flex direction={"column"} gap={20} className={styles["comp__features"]}>
        {POINTS.map((p) => (
          <Flex
            key={p.label}
            align={"center"}
            gap={12}
            className={styles["comp__features__item"]}
          >
            <img
              className={styles["comp__features__item__icon"]}
              src={p.iconUrl}
              alt=""
            />
            <div
              className={styles["comp__features__item__label"]}
              dangerouslySetInnerHTML={{ __html: p.label }}
            />
          </Flex>
        ))}
      </Flex>

      {isMobile && (
        <div className={styles["comp__mobileWarning"]}>
          <p className={styles["comp__mobileWarning__text"]}>
            {t("mobileWarning")}
          </p>
        </div>
      )}

      {currentStep === 3 && (
        <Button
          className={styles["comp__button"]}
          href={`${(APP_ORIGIN || "http://localhost:3001").replace(/\/+$/, "")}/${locale}`}
        >
          {t("tryForFree")}
        </Button>
      )}
    </div>
  );
};
